import React from 'react';
import Header from './Header';
import Hero from './Hero';
import About from './About';
import Stats from './Stats';
import Experience from './Experience';
import Skills from './Skills';
import FeaturedProject from './FeaturedProject';
import Education from './Education';
import Certifications from './Certifications';
import TechStack from './TechStack';
import Contact from './Contact';
import Footer from './Footer';
import AnimatedBackground from './AnimatedBackground';

const Portfolio = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 transition-colors duration-500 relative">
      <AnimatedBackground />
      <Header />
      <main className="relative z-10">
        <Hero />
        <About />
        <Stats />
        <Experience />
        <Skills />
        <FeaturedProject />
        <Education />
        <Certifications />
        <TechStack />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Portfolio;
